// extracted by mini-css-extract-plugin
module.exports = {"wrapperFound":"_2rny_","header":"_3qPGU","text":"oz0av","title":"_3FCUZ","secondBlock":"f9UTh","topCategories":"_3ImHs","secondTitle":"Zfjva"};